import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Alert } from "react-bootstrap";
import axios from "axios";

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalLicenses: 0,
    activeLicenses: 0,
    expiredLicenses: 0,
    recentActivations: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    // Fetch license stats
    const fetchStats = async () => {
      try {
        setLoading(true);
        setError("");
        const licensesResponse = await axios.get("/api/licenses");
        const activationsResponse = await axios.get("/api/activations");

        const licenses = licensesResponse.data;
        const activations = activationsResponse.data;
        const now = new Date();

        // Calculate statistics
        const totalLicenses = licenses.length;
        const activeLicenses = licenses.filter(
          (license) =>
            license.status === "active" && new Date(license.expires_at) > now
        ).length;
        const expiredLicenses = licenses.filter(
          (license) => new Date(license.expires_at) < now
        ).length;

        // Count activations in the last 30 days
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        const recentActivations = activations.filter(
          (activation) => new Date(activation.timestamp) > thirtyDaysAgo
        ).length;

        setStats({
          totalLicenses,
          activeLicenses,
          expiredLicenses,
          recentActivations,
        });
        setLoading(false);
      } catch (error) {
        console.error("Error fetching dashboard stats:", error);
        if (error.response && error.response.status === 401) {
          setError("Your session has expired. Please log in again.");
          // The axios interceptor will handle the logout
        } else {
          setError("Failed to fetch dashboard data. Please try again later.");
        }
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return (
    <Container>
      <h2 className="my-4">Dashboard</h2>

      {error && (
        <Alert variant="danger" onClose={() => setError("")} dismissible>
          {error}
        </Alert>
      )}

      <Row className="dashboard-stats">
        <Col md={3}>
          <Card className="stat-card bg-primary text-white">
            <Card.Body>
              <div className="stat-value">{stats.totalLicenses}</div>
              <div className="stat-label">Total Licenses</div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="stat-card bg-success text-white">
            <Card.Body>
              <div className="stat-value">{stats.activeLicenses}</div>
              <div className="stat-label">Active Licenses</div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="stat-card bg-warning text-white">
            <Card.Body>
              <div className="stat-value">{stats.expiredLicenses}</div>
              <div className="stat-label">Expired Licenses</div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="stat-card bg-info text-white">
            <Card.Body>
              <div className="stat-value">{stats.recentActivations}</div>
              <div className="stat-label">Recent Activations</div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col md={12}>
          <Card>
            <Card.Header>System Status</Card.Header>
            <Card.Body>
              <p>
                License Server: <span className="text-success">Online</span>
              </p>
              <p>
                Database: <span className="text-success">Connected</span>
              </p>
              <p>
                API Health: <span className="text-success">Operational</span>
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
